import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  user-select: none;
  width: 260px;
  ${bp('sm')`
    width: 100%;
    padding: 0 10px;
  `}

  ul {
    padding: 0;
    list-style: none;
    ${bp('sm')`
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    `}

    li {
      margin: 20px 0;

      a {
        color: ${props => props.theme.palette.general.dark};
        text-decoration: none;
        font-size: 15px;
        transition: all ease-in-out 0.3s;
        ${bp('sm')`
          padding: 5px 10px;
        `}

        &.selected {
          color: ${props => props.theme.palette.primary.alphaDark};
          font-weight: bold;
        }

        &:hover {
          opacity: 0.8;
        }
      }

      &.isDisabled {
        display: none;
      }
    }
  }

  button {
    font-size: 14px;
    color: ${props => props.theme.palette.general.grey};
    padding: 5px;
    border: 1px solid ${props => props.theme.palette.general.greyLight};
    background: ${props => props.theme.palette.general.soft};
    border-radius: 2px;
    cursor: pointer;
  }
`
export const Title = styled.div`
  font: ${font('default', 'medium', '18px/1')};
  margin-bottom: 30px;
`
